import React from "react";


export default function footer(){
return(


  <footer id="footer">
                  
                    <div class="footer-top">
                
                      <div class="container">
                
                        <div class="row  justify-content-center">
                          <div class="col-lg-6">
                            <h3>Cosmos</h3>
                          </div>
                        </div>
                
                        <div class="row footer-newsletter justify-content-center">
                          <div class="col-lg-6">
                            <form action="" method="post">
                              <input type="email" name="email" placeholder="Enter your Email"/><input type="submit" value="Subscribe"/>
                            </form>
                          </div>
                        </div>
                
                        <div class="social-links">
                          <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a>
                          <a href="https://www.instagram.com/cosmos_iitm/" class="facebook"><i class="bx bxl-facebook"></i></a>
                          <a href="" class="https://www.instagram.com/cosmos_iitm/"><i class="bx bxl-instagram"></i></a>
                          <a href="#" class="google-plus"><i class="bx bxl-skype"></i></a>
                          <a href="https://www.linkedin.com/company/cosmos-iitm" class="linkedin"><i class="bx bxl-linkedin"></i></a>
                        </div>
                
                      </div>
                    </div>
                
                    <div class="container footer-bottom clearfix">
                      <div class="copyright">
                        &copy; Copyright <strong><span>Team Cosmos</span></strong>. All Rights Reserved
                      </div>
                      <div class="credits">
                        {/* <!-- -->
                        <!--  -->
                        <!--  -->
                        <!--  --> */}
                        Designed by <a href="https://github.com/nikhilisaac">Cosmos_Webdev Team</a>
                      </div>
                    </div>
</footer>
                         
)


}
        
            

